var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDr = function SvgDr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 150
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-5%",
    y: "-3.5%",
    width: "109.9%",
    height: "109.9%",
    filterUnits: "objectBoundingBox",
    id: "d_r_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-2.8%",
    width: "108.5%",
    height: "108.5%",
    filterUnits: "objectBoundingBox",
    id: "d_r_svg__c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-8%",
    y: "-4.6%",
    width: "115.9%",
    height: "118.3%",
    filterUnits: "objectBoundingBox",
    id: "d_r_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "d_r_svg__b",
    cx: 70.4,
    cy: 70.921,
    rx: 70.4,
    ry: 70.921
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "d_r_svg__e",
    cx: 70.4,
    cy: 70.891,
    rx: 59.661,
    ry: 60.159
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d_r_svg__a)",
    xlinkHref: "#d_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#002D41",
    xlinkHref: "#d_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d_r_svg__c)",
    xlinkHref: "#d_r_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d_r_svg__d)",
    xlinkHref: "#d_r_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#414F76",
    xlinkHref: "#d_r_svg__e"
  })), /*#__PURE__*/React.createElement("text", {
    className: "d_r_svg__virtualBox_TextInSvg",
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
    fontSize: 63.8,
    letterSpacing: -0.768,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 52.4,
    y: 93.9
  }, "D")))));
};

export default SvgDr;